import { nativePlatform } from './native';
import { detectPlatformKind } from './runtime';
import { webPlatform } from './web';
import type { FileSaveOutcome, Platform } from './types';

export type {
  AppInfo,
  AuthTransport,
  FileSaveOutcome,
  Platform,
  PlatformApp,
  PlatformBrowser,
  PlatformDeepLinks,
  PlatformFiles,
  PlatformKind,
  PlatformLifecycle,
  PlatformNetwork,
  Unsubscribe,
} from './types';
export { deepLinkToPath, APP_URL_SCHEME } from './deepLinks';
export { PUBLIC_SITE_ORIGIN, publicSiteUrl } from './site';

let current: Platform | null = null;

export function getPlatform(): Platform {
  current ??= detectPlatformKind() === 'native' ? nativePlatform : webPlatform;
  return current;
}

export function isNativePlatform(): boolean {
  return getPlatform().kind === 'native';
}

/** Hands a generated file to the user, the way the current platform allows. */
export function saveFile(blob: Blob, filename: string): Promise<FileSaveOutcome> {
  return getPlatform().files.save(blob, filename);
}

/** Tests only: detect the platform again on the next call. */
export function __resetPlatform(): void {
  current = null;
}
